import type { DefectDetailsData } from "@stryker/core/types/sections";
import { useShallow } from "zustand/react/shallow";
import ExpandableSection from "@/components/job/ExpandableSection";
import useCUMechanicalJobStore from "@/store/useCUMechanicalJobStore";

import { FlangeClampDefectDetails } from "./FlangeClampDefectDetails";
import { LongRadius90DefectDetails } from "./LongRadius90DefectDetails";
import { StraightLineDefectDetails } from "./StraightLineDefectDetails";
import { TeeDefectDetails } from "./TeeDefectDetails";

const cardName = "defectDetails";

export function DefectDetails() {
  const { sections, toggleExpandableSection, setDefectDetails } = useCUMechanicalJobStore(
    useShallow((state) => ({
      sections: state.sections,
      toggleExpandableSection: state.toggleExpandableSection,
      setDefectDetails: state.setDefectDetails,
    }))
  );

  const savedDefectDetails = sections.defectDetails;
  const repairType = sections.repairType.data.repairType;

  const handleSaveDefectDetails = (data: DefectDetailsData) => {
    setDefectDetails({
      data,
      status: "done",
    });
  };

  const renderDefectDetailsComponent = () => {
    switch (repairType) {
      case "straight_line":
        return <StraightLineDefectDetails onSave={handleSaveDefectDetails} />;
      case "long_radius":
        return <LongRadius90DefectDetails onSave={handleSaveDefectDetails} />;
      case "tee":
        return <TeeDefectDetails onSave={handleSaveDefectDetails} />;
      case "flange_clamp":
        return <FlangeClampDefectDetails onSave={handleSaveDefectDetails} />;
      default:
        return <StraightLineDefectDetails onSave={handleSaveDefectDetails} />;
    }
  };

  return (
    <ExpandableSection
      status={savedDefectDetails.status}
      setIsExpanded={() => toggleExpandableSection(cardName)}
      title="Defect Details"
    >
      {renderDefectDetailsComponent()}
    </ExpandableSection>
  );
}
